/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { TodoListBusinessService } from '../../../resources/todo-list-business.service';

import { PassTodoDialogComponent } from './pass-todo-dialog.component';

export const passTodoDialog = createDialogRoute({
  component: PassTodoDialogComponent,
  init: TodoListBusinessService,
});
